import cacheLs from "../cacheLs"

export default {
  addSelectedDate (state, data) {
    state.selectedDate = { ...data }
    cacheLs.set_date_filter(data)
  }
}
